module.exports = __webpack_public_path__ + "img/sjl.9f3d7840.png";